<template>
  <SvoiLabel v-bind="$props" />
</template>

<script lang="ts" setup>
  import { SvoiLabel } from '@svoi-ui/components/label'

  defineProps<{
    name: string
    size?: string
    theme?: string
    iconLeft?: string
    iconRight?: string
    onClick?: (...args: any[]) => any
  }>()
</script>